
import React, {Component} from "react";
import {BrowserRouter as Router, Switch, Route, Link} from "react-router-dom";

import { Button, Card, Container, Row, Col, CardDeck, Image, OverlayTrigger, Tooltip, Alert, ContextAwareToggle, Badge, ToggleButtonGroup, ToggleButton} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'w3-css/w3.css';

// Don't remove these, otherwise text becomes funky.
// import {PricingTable, PricingSlot, PricingDetail} from 'react-pricing-table';

import '../styling/home.css';
import '../styling/pricing-billing.css';
import HomeFooter from '../components/HomeFooter';
import HomePageIndex from '../components/HomePageIndex';

// import windowSize from 'react-window-size';

import { demo_items_list } from "../demo_items.js";
import { pricing_plan_list } from "../pricing_plans.js";

import '@google/model-viewer/dist/model-viewer';

import * as QrCode from 'qrcode.react'

import config from '../config'

// import 'rc-footer/assets/index.css'; // import 'rc-footer/asssets/index.less';

// Browser icons.

// Social media.
import youtube_icon from '../icons/youtube.png';

// Other icons.
import next_icon from '../icons/next.png';
import prev_icon from '../icons/previous.png';

import up_arrow from '../icons/up-arrow.png';
import registration_icon from '../icons/google-fonts/registration.png';
import view_in_ar_icon from '../icons/google-fonts/view-in-ar.png';
import read from '../icons/google-fonts/read.png';
import scanQR from '../icons/icons8-scan-96.png'

// gif_image.
//import xenkia_gif from '../gifs/gif_xenkia_chair.gif';
import xenkia_gif from '../gifs/gif_xenkia_chair.gif';

// Reflection image.
import environment_hdr from '../environment_hdr/sidekix-media-BAVam-y_9Wg-unsplash.jpg';

// Modal based MessageBox Class.


/**
 * Global variables.
 */
var demoAssets =[];
var individualPricingPlan =[];
var companyPricingPlan =[];

// When the home page gas been loaded for the first time, this flag will be set.
var flag_loaded = 0;

// Default Billing-Cycle and Cost values passed through URL as parameters.
var default_billing_cycle = "";
var default_cost = "";

const Explore3DIcon = () => (
    <svg className="view3dButtonIcon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M12 3 20 7.5v9L12 21l-8-4.5v-9L12 3Z" />
        <path d="m4.3 7.7 7.7 4.4 7.7-4.4M12 12.1V21" />
    </svg>
);

const IndividualIcon = () => (
    <svg className="pricing-audience-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <circle cx="12" cy="8" r="3.25" />
        <path d="M5.5 20v-1.2a6.5 6.5 0 0 1 13 0V20" />
    </svg>
);

const EnterpriseIcon = () => (
    <svg className="pricing-audience-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M4.5 21V4.5h10V21M14.5 9h5V21M2.5 21h19" />
        <path d="M7.5 8h1.75M7.5 11.5h1.75M7.5 15h1.75M11 8h1.25M11 11.5h1.25M11 15h1.25M17 12h.5M17 15.5h.5" />
    </svg>
);

const BenefitIcon = ({ type }) => {
    const iconShapes = {
        embed: <path d="m8 8-4 4 4 4M16 8l4 4-4 4M14 5l-4 14" />,
        auto: <><path d="M7 3h7l4 4v14H7z" /><path d="M14 3v5h5M10 13h5M10 17h5" /><path d="m4 8 .6 1.4L6 10l-1.4.6L4 12l-.6-1.4L2 10l1.4-.6z" /></>,
        sliders: <><path d="M4 7h7M15 7h5M4 17h3M11 17h9M4 12h2M10 12h10" /><circle cx="13" cy="7" r="2" /><circle cx="9" cy="17" r="2" /><circle cx="8" cy="12" r="2" /></>,
        website: <><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M3 9h18M7 6.5h.01M10 6.5h.01" /><path d="m10 13 5 3-5 3z" /></>,
        qr: <><path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4z" /><path d="M14 14h2v2h-2zM18 14h2M18 18v2M14 18h2v2" /></>,
        devices: <><rect x="3" y="5" width="13" height="10" rx="1.5" /><path d="M8 19h3M9.5 15v4" /><rect x="17" y="8" width="4" height="10" rx="1" /></>,
        dimensions: <><path d="M4 7h16M4 17h16M7 4v6M12 5v4M17 4v6M7 14v6M12 15v4M17 14v6" /></>,
        explore: <><circle cx="12" cy="12" r="9" /><path d="m15.5 8.5-2.2 4.8-4.8 2.2 2.2-4.8z" /></>,
        ar: <><path d="m12 3 8 4.5v9L12 21l-8-4.5v-9z" /><path d="m4.5 7.8 7.5 4.3 7.5-4.3M12 12v8.5" /><path d="M18 3v4M16 5h4" /></>,
        craft: <><path d="m14 6 4-4 4 4-4 4" /><path d="m17 7-8 8M5 13l6 6M4 20l3-3M3 15l6-6" /><path d="m13 18 2 2 6-6-2-2" /></>
    };

    return <svg className="home-benefit-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">{iconShapes[type]}</svg>;
};

const getSignupPath = (accountType, pricingPlan, billingCycle) => {
    const params = new URLSearchParams({ accountType, pricingPlan, billingCycle });
    return `/signupform?${params.toString()}`;
};

/**
 * Home class.
 */
class Home extends Component {
    
    state = {   
                demoAssets:                 [], 
                width:                      640, 
                height:                     480,
                individualOrCompany:        0,
                billMonthlyOrYearly:        'Monthly',
                goToTopVisible:             false,
                goToTopButtonPosY:          0,

                windowInnerWidth:           0
            };


    num_of_demo_items_set           = 0;            // This variable stores the total number of Sets of Demo Assets in the 'demo_items.js' file.
    currently_selected_batch        = 1;            // This is the Currently Selected Batch of Demo Items.
    UNSAFE_componentWillMount(){                

        // console.log(window.innerWidth);
        
        this.setState({width: window.innerWidth,   height: window.innerHeight});


        if (flag_loaded !== 1)
        {
            // Load the demo assets.
            this.loadDemoAssets();
            this.loadPricingPlan();
        }

        //console.log("component will mount", flag_loaded);      
        
        // Everytime the Window is Resized, thie event gets fired.
        window.addEventListener('resize', (event) =>{
            this.toggleGoToTopButtonVisibility();
        });

        // Everytime the Window is Scrolled, thie event gets fired.
        window.addEventListener('scroll', (event) =>{
            this.toggleGoToTopButtonVisibility();
        });

        // Run this at the begining once, so that the GoToTop button appears based on the current window size.
        this.toggleGoToTopButtonVisibility();

        // Everytime the Window is Resized, thie event gets fired.
        window.addEventListener('resize', (event) =>{
            this.setState({width: window.innerWidth,   height: window.innerHeight});
          });
    }


    UNSAFE_componentDidMount()
    {
        // Set the flag to mark that the components have already mounted once. This is mandatory.
        flag_loaded = 1;

        // Set the Resolution of the current window.
        //this.setState({width: this.props.windowWidth.toString()+'px',   height: this.props.windowHeight.toString()+'px'});
        //this.setState({width: window.innerWidth.toString()+'px',   height: window.innerHeight.toString()+'px'});
    }

    // This function will scroll the page to the top.
    // Note: https://www.coderomeos.org/scroll-to-top-of-the-page-a-simple-react-component
    scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }

    // Show button when page is over a certain width.
    toggleGoToTopButtonVisibility (){

        //console.log((window.scrollY/window.innerHeight)*100 + "%");

        //console.log(window.innerWidth - 5);

        // The "GoToTop" button should appear 150px inside of the current window.innerWidth.
        this.setState({goToTopButtonPosY: (window.innerWidth - 150)});

        // The "GoToTop" button should appear when the window.innerWidth is greater than 1024px and 100% of the page height (when its first loaded) has been scrolled down.
        //if ( (window.innerWidth > 1024) && ((window.scrollY/window.innerHeight)*100 > 100)) {
        if ( (window.scrollY/window.innerHeight)*100 > 100) {

            this.setState({goToTopVisible: true})
        } else {
            this.setState({goToTopVisible: false})
        }
    };


    showEmail = () =>
    {
        alert('info@xenkia.com');
    }

    selectBillingCycle = (cycle) =>
    {
        this.setState({billMonthlyOrYearly: cycle});
        this.loadPricingPlan(cycle);
    }


    // Select the Previous Batch of Demo Items.
    selectPreviousBatch = () =>
    {
        if (this.currently_selected_batch > 1) this.currently_selected_batch--;
        else this.currently_selected_batch = this.num_of_demo_items_set;

        this.loadDemoAssets();

        //console.log("previous batch: ", this.currently_selected_batch);
    }

    // Select the Next Batch of Demo Items.
    selectNextBatch = () =>
    {
        if (this.currently_selected_batch < this.num_of_demo_items_set) this.currently_selected_batch++;
        else this.currently_selected_batch = 1;

        this.loadDemoAssets();

        //console.log("next batch", this.currently_selected_batch);
    }


    

    /**
     * Load the Pricing Plan from Server.
     */
     loadPricingPlan = (selectedPlan) => {


        // Load all the Individual Pricing plans.
        individualPricingPlan = [];
        pricing_plan_list[0].forEach(element => {
            const isStarterPlan = element.plan === 'Starter';
            const isStarterYearly = isStarterPlan && selectedPlan === 'Yearly';

            // Select the 'default_billing_cycle' to pass as parameters to the /SignUpForm/
            if(selectedPlan === 'Yearly')
            {
                default_billing_cycle       ='Yearly';
                default_cost                = element.yearly_cost_in_usd;
            } else{
                default_billing_cycle       ='Monthly';
                default_cost                = element.monthly_cost_in_usd;
            }


            individualPricingPlan.push(
                <Card
                    bg='Light'
                    text='dark'
                    className="pricingPackageZoom pricing-plan-card"
                >
                    <Card.Header className={`pricing-card-header${isStarterYearly ? ' starter-plan-header' : ''}`}><b>{element.plan}</b></Card.Header>
                    <Card.Body className="pricing-plan-card-body">
                        {selectedPlan === 'Yearly' && !isStarterPlan
                            ?
                                <section>
                                    <Card.Title className="pricing-card-price"> <b><td dangerouslySetInnerHTML={{__html: element.yearly_cost}} /></b> </Card.Title>
                                </section>
                            :
                                <section>
                                    <Card.Title className={`pricing-card-price${isStarterYearly ? ' starter-plan-price' : ''}`}> <b><td dangerouslySetInnerHTML={{__html: element.cost}} /></b> </Card.Title>
                                </section>
                        }
                        <Card.Text as="div" className="pricing-card-description">
                            <h5 className="pricing-card-goodfor"> <td dangerouslySetInnerHTML={{__html: element.good_for}} /></h5>
                            <div className="pricing-card-feature-list">
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature1}} />
                                <br/>
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature2}} />
                                <br/>
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature3}} />
                                <br/>
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature4}} />
                                <br/>
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature5}} />
                                <br/>
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature6}} />
                                <br/>
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature7}} />
                                <br/>
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature8}} />
                                <br/>
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature9}} />
                                <br/>
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature10}} />
                            </div>
                        </Card.Text>

                        {/* <Button variant="success" size="lg" as={Link} to={"/signupform/"+element.plan+"/"+default_billing_cycle+default_cost+"/"}><b>Subscribe to this Package</b></Button> */}
                        {/* <Button style={{boxShadow: "1px 1px 8px grey"}} variant="warning" size="lg" as={Link} to={"/signupform/params=1&pricingPlan="+element.plan+"&accountType=Personal&billingCycle="+default_billing_cycle}> <img src={registration_icon} alt="registration" width="32" height="32"/> <b> Subscribe</b></Button> */}
                        {isStarterPlan && selectedPlan === 'Yearly' ? (
                            <>
                                <p className="pricing-unavailable-note" role="status">Starter is available with monthly billing. Switch to monthly pricing to subscribe.</p>
                                <Button className="pricing-subscribe-button" variant="primary" size="lg" disabled aria-disabled="true"> <img src={registration_icon} alt="" width="32" height="32"/> <b>Subscribe</b></Button>
                            </>
                        ) : (
                            <Button className="pricing-subscribe-button" variant="primary" size="lg" as={Link} to={getSignupPath('Individual', element.plan, selectedPlan)}> <img src={registration_icon} alt="" width="32" height="32"/> <b> Subscribe</b></Button>
                        )}
                    </Card.Body>
                </Card>
                );
        });



        // Load all the Company Pricing plans.
        companyPricingPlan = [];
        pricing_plan_list[1].forEach(element => {

            // Select the 'default_billing_cycle' to pass as parameters to the /SignUpForm/
            if(selectedPlan === 'Yearly')
            {
                default_billing_cycle       ='Yearly';
                default_cost                = element.yearly_cost_in_usd;
            } else{
                default_billing_cycle       ='Monthly';
                default_cost                = element.monthly_cost_in_usd;
            }

            companyPricingPlan.push(
                <Card
                    bg='Light'
                    text='dark'
                    className="pricingPackageZoom pricing-plan-card"
                >
                    <Card.Header className="pricing-card-header"><b>{element.plan}</b></Card.Header>
                    <Card.Body className="pricing-plan-card-body">
                        {selectedPlan === 'Yearly'
                            ?
                                <section>
                                    <Card.Title className="pricing-card-price"> <b><td dangerouslySetInnerHTML={{__html: element.yearly_cost}} /></b> </Card.Title>
                                </section>
                            :
                                <section>
                                    <Card.Title className="pricing-card-price"> <b><td dangerouslySetInnerHTML={{__html: element.cost}} /></b> </Card.Title>                                    
                                </section>
                        }
                        <Card.Text as="div" className="pricing-card-description">
                            <h5 className="pricing-card-goodfor"><td dangerouslySetInnerHTML={{__html: element.good_for}} /></h5>
                            <div className="pricing-card-feature-list">
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature1}} />
                                <br/>
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature2}} />
                                <br/>
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature3}} />
                                <br/>
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature4}} />
                                <br/>
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature5}} />
                                <br/>
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature6}} />
                                <br/>
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature7}} />
                                <br/>
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature8}} />
                                <br/>
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature9}} />
                                <br/>
                                <td className="pricing-card-features" dangerouslySetInnerHTML={{__html: element.feature10}} />
                            </div>
                        </Card.Text>

                        {/* <Button variant="warning" size="lg" as={Link} to={"/signupform/"+element.plan+"/"+default_billing_cycle+default_cost+"/"}><b>Subscribe to this Package</b></Button> */}
                        {/* <Button style={{boxShadow: "1px 1px 8px grey"}} variant="warning" size="lg" as={Link} to={"/signupform/params=1&pricingPlan="+element.plan+"&accountType=Company&billingCycle="+default_billing_cycle}> <img src={registration_icon} alt="registration" width="32" height="32"/> <b>Subscribe</b></Button> */}
                        <Button className="pricing-subscribe-button" variant="primary" size="lg" as={Link} to={getSignupPath('Company', element.plan, selectedPlan)}> <img src={registration_icon} alt="registration" width="32" height="32"/> <b>Subscribe</b></Button>
                    </Card.Body>
                </Card>
                );
        });
    }




    /**
     * Load the Demo Assets from Server.
     */
    loadDemoAssets = (e) => {

        // Get the Number of Sets of Demo items.
        this.num_of_demo_items_set = 0;
        demo_items_list.forEach(element => {
            this.num_of_demo_items_set = this.num_of_demo_items_set + 1;
        });
        //console.log(this.num_of_demo_items_set);


        // Load all the Demo Assets in a file.
        demoAssets = [];
        //this.setState({demoAssets: []});
        demo_items_list[this.currently_selected_batch-1].forEach(element => {
            //console.log(element);

            if(window.innerWidth>2000)
            // if(this.state.width>2000)
            {
                demoAssets.push(
                    <Card
                        className="p-3 card-margin demo-model-card"
                        style={{ width: '32rem', alignItems: 'center', justifyContent: 'center', boxShadow: "1px 1px 10px grey"}}
                        bg="light"
                        text='dark'
                    >
                    <model-viewer
                        environment-image={environment_hdr}
                        shadow-intensity="1" 
                        shadow-softness="1"
                        style={{ width: '480px', height: '360px', backgroundColor: '#f7f7f7', justifyContent: 'center'}} 
                        // src={element.model_address}
                        src={"https://xenkiaassetbucket.s3-accelerate.amazonaws.com/protected/us-east-1%3A008a3f2b-57b4-4a55-ab16-c7b4c2c01c85/asset/" + element.uuid + "/" + element.uuid + ".glb"}
                        //poster={element.poster_address}
                        poster={"https://xenkiaassetbucket.s3-accelerate.amazonaws.com/protected/us-east-1%3A008a3f2b-57b4-4a55-ab16-c7b4c2c01c85/asset/" + element.uuid + "/POSTER_" + element.uuid + ".png"}
                        alt="3D model"
                        autoplay 
                        exposure={element.exposure}
                        auto-rotate 
                        camera-controls
                        field-of-view={element.camera_field_of_view}
                        min-field-of-view="10deg"
                        max-field-of-view="170deg"
                        >                        
                    </model-viewer>

                    <Card.Body>
                        <h3 style={{fontFamily: 'Open Sans, sans-serif, Arial, Helvetica'}}> <b> {element.item_name} </b></h3>
                        {/* <h5 className="card-title"> <a href={element.src_address} target="_blank" rel="noreferrer" style={{color: '#006EFF'}}> <u><i>{element.src_name}</i></u> </a> </h5> */}


                        {/* <hr/> */}
                            {/*{element.hashtags.forEach(tag => {                                                                        
                                console.log(tag);
                                
                                <p> jasvdhjasd </p>
                            })}*/
                            }
                            {/* <h6 className="home-subtext" style={{color: 'green'}}> <i>{element.simple_hashtag}</i> </h6> */}
                        <hr/>

                        <br/>
                        {/* <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> <p style={{textAlign: 'center'}}>Click to open the model in 3d-viewer</p></Tooltip>}> */}
                            <Button className='btn-margin view3dButtonZoom' variant="primary" onClick={() => window.open(config.viewer3d.url + "#/&uuid=" + element.uuid)}><Explore3DIcon /><b>Explore in 3D</b></Button>
                        {/* </OverlayTrigger> */}

                        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> <p style={{textAlign: 'center'}}>Scan with your phone or tablet to open the 3D viewer, then choose AR to place the model in your space.</p> </Tooltip>}>
                            {/* <Image style={{width: '96px', height: '96px'}} src={element.qr_code_address}/> */}
                            {/* Note: https://zpao.github.io/qrcode.react/ */}
                            <QrCode 
                                value={config.viewer3d.url + "#/&uuid=" + element.uuid}
                                size={128} 
                                id="qrCode" 
                                includeMargin={true} 
                                level='M'
                                renderAs={"svg"}
                                imageSettings={{
                                    src:      scanQR,
                                    x:        null,
                                    y:        null,
                                    height:   24,
                                    width:    24,
                                    excavate: true,
                                }}
                            />
                        </OverlayTrigger>
                        <p style={{color: '#006EFF', fontSize: '14px'}}> <b> Scan to open 3D viewer </b> </p>

                        <img className="buttonZoom" height='32px' width='32px' src={youtube_icon} alt="youtube" onClick={() => window.open(element.youtube_video_address)}/>
                    </Card.Body>
                    </Card>
                );
            }
            else if(window.innerWidth>1700)
            // else if(this.state.width>1700)
            {
                demoAssets.push(
                    <Card
                        className="p-3 card-margin demo-model-card"
                        style={{ width: '24rem', alignItems: 'center', justifyContent: 'center', boxShadow: "1px 1px 5px grey"}}
                        bg="light"
                        text='dark'
                    >
                    <model-viewer
                        environment-image={environment_hdr}
                        shadow-intensity="1" 
                        shadow-softness="1"
                        style={{ width: '320px', height: '240px', backgroundColor: '#f7f7f7', justifyContent: 'center'}} 
                        // src={element.model_address}
                        src={"https://xenkiaassetbucket.s3-accelerate.amazonaws.com/protected/us-east-1%3A008a3f2b-57b4-4a55-ab16-c7b4c2c01c85/asset/" + element.uuid + "/" + element.uuid + ".glb"}
                        poster={"https://xenkiaassetbucket.s3-accelerate.amazonaws.com/protected/us-east-1%3A008a3f2b-57b4-4a55-ab16-c7b4c2c01c85/asset/" + element.uuid + "/POSTER_" + element.uuid + ".png"}
                        //poster={element.poster_address}
                        alt="3D model"
                        autoplay 
                        exposure={element.exposure}
                        auto-rotate 
                        camera-controls
                        field-of-view={element.camera_field_of_view}
                        min-field-of-view="10deg"
                        max-field-of-view="170deg"
                        >                        
                    </model-viewer>

                    <Card.Body>
                        <h3 style={{fontFamily: 'Open Sans, sans-serif, Arial, Helvetica'}}> <b> {element.item_name} </b></h3>
                        {/* <h5 className="card-title"> <a href={element.src_address} target="_blank" rel="noreferrer" style={{color: '#006EFF'}}> <u><i>{element.src_name}</i></u> </a> </h5> */}


                        {/* <hr/> */}
                            {/*{element.hashtags.forEach(tag => {                                                                        
                                console.log(tag);
                                
                                <p> jasvdhjasd </p>
                            })}*/
                            }
                            {/* <h5 className="home-subtext" style={{color: '#006EFF'}}> <i>{element.simple_hashtag}</i> </h5> */}
                        <hr/>

                        <br/>
                        {/* <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> <p style={{textAlign: 'center'}}>Click to open the model in 3d-viewer</p></Tooltip>}> */}
                        <Button className='btn-margin view3dButtonZoom' variant="primary" onClick={() => window.open(config.viewer3d.url + "#/&uuid=" + element.uuid)}><Explore3DIcon /><b>Explore in 3D</b></Button>
                        {/* </OverlayTrigger> */}

                        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> <p style={{textAlign: 'center'}}>Scan with your phone or tablet to open the 3D viewer, then choose AR to place the model in your space.</p> </Tooltip>}>
                            {/* <Image style={{width: '96px', height: '96px'}} src={element.qr_code_address}/> */}
                            {/* Note: https://zpao.github.io/qrcode.react/ */}
                            <QrCode 
                                value={config.viewer3d.url + "#/&uuid=" + element.uuid}
                                size={128} 
                                id="qrCode" 
                                includeMargin={true} 
                                level='M'
                                renderAs={"svg"}
                                imageSettings={{
                                    src:      scanQR,
                                    x:        null,
                                    y:        null,
                                    height:   24,
                                    width:    24,
                                    excavate: true,
                                }}
                            />
                        </OverlayTrigger>
                        <p style={{color: '#006EFF', fontSize: '14px'}}> <b> Scan to open 3D viewer </b> </p>

                        <img className="buttonZoom" height='32px' width='32px' src={youtube_icon} alt="youtube" onClick={() => window.open(element.youtube_video_address)}></img>
                    </Card.Body>
                    </Card>
                );
            }
            else{
                demoAssets.push(
                    <Card
                        className="p-3 card-margin demo-model-card"
                        style={{ width: '24rem', alignItems: 'center', justifyContent: 'center', boxShadow: "1px 1px 5px grey"}}
                        bg="light"
                        text='dark'
                    >
                    <model-viewer
                        environment-image={environment_hdr}
                        shadow-intensity="1" 
                        shadow-softness="1"
                        style={{ width: '320px', height: '240px', backgroundColor: '#f7f7f7', justifyContent: 'center'}} 
                        // src={element.model_address}
                        src={"https://xenkiaassetbucket.s3-accelerate.amazonaws.com/protected/us-east-1%3A008a3f2b-57b4-4a55-ab16-c7b4c2c01c85/asset/" + element.uuid + "/" + element.uuid + ".glb"}
                        poster={"https://xenkiaassetbucket.s3-accelerate.amazonaws.com/protected/us-east-1%3A008a3f2b-57b4-4a55-ab16-c7b4c2c01c85/asset/" + element.uuid + "/POSTER_" + element.uuid + ".png"}
                        //poster={element.poster_address}
                        alt="3D model"
                        autoplay 
                        exposure={element.exposure}
                        auto-rotate 
                        camera-controls
                        field-of-view={element.camera_field_of_view}
                        min-field-of-view="10deg"
                        max-field-of-view="170deg"
                        > 
                    </model-viewer>

                    <Card.Body>
                        <h3 style={{fontFamily: 'Open Sans, sans-serif, Arial, Helvetica'}}> <b> {element.item_name} </b></h3>
                        {/* <h5 className="card-title"> <a href={element.src_address} target="_blank" rel="noreferrer" style={{color: '#006EFF'}}> <u><i>{element.src_name}</i></u> </a> </h5> */}
                       
                        {/* <hr/> */}
                            {/*{element.hashtags.forEach(tag => {                                                                        
                                console.log(tag);
                                
                                <p> jasvdhjasd </p>
                            })}*/
                            }
                        {/* <h5 className="home-subtext" style={{color: '#006EFF'}}> <i>{element.simple_hashtag}</i> </h5> */}
                        <hr/>

                        <br/>
                        {/* <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> <p style={{textAlign: 'center'}}>Click to open the model in 3d-viewer</p></Tooltip>}> */}
                        <Button className='btn-margin view3dButtonZoom' variant="primary" onClick={() => window.open(config.viewer3d.url + "#/&uuid=" + element.uuid)}><Explore3DIcon /><b>Explore in 3D</b></Button>
                        {/* </OverlayTrigger> */}

                        <p> <b>OR</b> </p>

                        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> <p style={{textAlign: 'center'}}>Scan with your phone or tablet to open the 3D viewer, then choose AR to place the model in your space.</p> </Tooltip>}>
                            {/* <Image style={{width: '96px', height: '96px'}} src={element.qr_code_address}/> */}
                            {/* Note: https://zpao.github.io/qrcode.react/ */}
                            <QrCode 
                                value={config.viewer3d.url + "#/&uuid=" + element.uuid}
                                size={128} 
                                id="qrCode" 
                                includeMargin={true} 
                                level='M'
                                renderAs={"svg"}
                                imageSettings={{
                                    src:      scanQR,
                                    x:        null,
                                    y:        null,
                                    height:   24,
                                    width:    24,
                                    excavate: true,
                                }}
                            />
                        </OverlayTrigger>
                        <p style={{color: '#006EFF', fontSize: '12px'}}> <b> Scan to open 3D viewer </b> </p>

                        {/* <Row style={{justifyContent: 'center', alignItems: 'center'}}> */}
                            <img className="buttonZoom" height='32px' width='32px' src={youtube_icon} alt="youtube" onClick={() => window.open(element.youtube_video_address)}></img>
                        {/* </Row> */}
                        <br/>
                        {/*<Row style={{justifyContent: 'center', alignItems: 'center'}}>
                            <Button variant="primary" onClick={this.selectNextBatch}> 
                                Next Item
                            </Button>
                        </Row>*/
                        }
                        
                    </Card.Body>
                    </Card>
                );
            }
        });

        this.setState({demoAssets: []});
        this.setState({demoAssets: [this.state.demoAssets, demoAssets]})
        //console.log(this.state.demoAssets);
    }




    /**
     * Rendering Starts here.
     */
    render() {

        //const {uploadPercentage} = this.state.percentage;
        

        return (
        
            <div>                  
                <div className="Model-Showcase">
        <section id="home-showcase" className="home-showcase-panel" aria-labelledby="home-hero-title">
                        <br/> <br/>
                        <div className="home-hero-content">
                            <p className="home-hero-eyebrow">
                                <svg viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="m12 3 7.2 4.1v9.1L12 20l-7.2-3.8V7.1L12 3Z" />
                                    <path d="m4.8 7.1 7.2 4.1 7.2-4.1M12 11.2V20" />
                                </svg>
                                <span>INTERACTIVE 3D + AUGMENTED REALITY</span>
                            </p>
                            <h1 id="home-hero-title" className="home-hero-title">Bring Your Products to Life Online</h1>
                            <p className="home-hero-description">Let customers explore your products in interactive 3D, switch between materials, view animations, and experience them in augmented reality.</p>
                            <div className="home-hero-actions">
                                <Link className="home-hero-button home-hero-button-primary" to={getSignupPath('Individual', 'Starter', 'Monthly')} style={{textDecoration: 'none'}}>
                                    <span>Start Free</span>
                                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13m-5-5 5 5-5 5" /></svg>
                                </Link>
                                <Link className="home-hero-button home-hero-button-secondary" to="/live-demo" style={{textDecoration: 'none'}}>
                                    <svg className="home-hero-play-icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="m10 8.5 5.5 3.5-5.5 3.5z" /></svg>
                                    <span>Explore Live Demos</span>
                                </Link>
                            </div>
                            <p className="home-hero-note">Free plan available <span aria-hidden="true">&middot;</span> No installation required</p>
                            <br/>
                        </div>

                        <br/>

                        <div className="home-showcase-divider" />
                        {/* <h2 className="home-showcase-title">Experience Xenkia in action</h2> */}
                        <div className="home-demo-area">
                            {/* <Container className="home-subheader audience-hashtags" fluid="xl">
                                    <Badge pill className="audience-hashtag">#3D-commerce</Badge>
                                    <Badge pill className="audience-hashtag">#Smart-Retail</Badge>
                                    <Badge pill className="audience-hashtag">#Web3D</Badge>
                                    <Badge pill className="audience-hashtag">#Product-visualization</Badge>
                                    <Badge pill className="audience-hashtag">#Hobbyist</Badge>
                                    <Badge pill className="audience-hashtag">#Maker</Badge>
                                    <Badge pill className="audience-hashtag">#Engineering</Badge>
                                    <Badge pill className="audience-hashtag">#Interior-Designing</Badge>
                                    <Badge pill className="audience-hashtag">#Architect</Badge>
                                    <Badge pill className="audience-hashtag">#E-commerce</Badge>
                                    <Badge pill className="audience-hashtag">#Furniture</Badge>
                                    <Badge pill className="audience-hashtag">#Fashion</Badge>
                                    <Badge pill className="audience-hashtag">#3D-art</Badge>
                                    <Badge pill className="audience-hashtag">#Web-developers</Badge>
                                    <Badge pill className="audience-hashtag">#Education</Badge>
                                    <Badge pill className="audience-hashtag">#Industry</Badge>
                            </Container>

                            <br/> */}

                            {/* <Container fluid>
                                <Row style={{justifyContent: 'center', alignItems: 'center'}}>
                                    <model-viewer 
                                        id='model'
                                        environment-image={environment_hdr}
                                        shadow-intensity="1" 
                                        shadow-softness="1" 
                                        style={{ width: '1024px', height: '768px', justifyContent: 'center', backgroundColor: "unset"}} 
                                        src="https://xenkia55844-vscode.s3-accelerate.amazonaws.com/protected/us-east-1%3A09842cfb-ac25-4050-9947-14fe78874f28/generator.glb"
                                        // poster={poster_address}
                                        alt="3D model" 
                                        auto-rotate 
                                        camera-controls 
                                        exposure="3"
                                        autoplay
                                        ar 
                                        ar-modes="scene-viewer webxr"> 
                                    </model-viewer>
                                </Row>
                            </Container> */}

                            <Container fluid>
                                {this.state.width>1700
                                ?
                                    <section>
                                        {//console.log("greater", this.state.width)
                                        }
                                        <Row className="demo-showcase-row">
                                            <img className="leftArrowButtonZoom" alt="previous" src={prev_icon} onClick={this.selectPreviousBatch}/>
                                                {demoAssets}
                                            <img className="rightArrowButtonZoom" alt="next" src={next_icon} onClick={this.selectNextBatch}/>
                                        </Row>
                                    </section>
                                :
                                    <section>
                                        {//console.log("less", this.state.width)
                                        }
                                        <Row style={{display: 'inline-flex', justifyContent: 'center', alignItems: 'center', maxWidth: '95%'}}>
                                            {demoAssets}
                                        </Row>
                                        <div className="demo-showcase-mobile-controls" aria-label="Model set navigation">
                                            <button type="button" aria-label="Show previous model set" onClick={this.selectPreviousBatch}>
                                                <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m15 18-6-6 6-6" /></svg>
                                            </button>
                                            <span>Explore other models</span>
                                            <button type="button" aria-label="Show next model set" onClick={this.selectNextBatch}>
                                                <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9 18 6-6-6-6" /></svg>
                                            </button>
                                        </div>
                                    </section>

                                }
                            </Container>
                        </div>
                    </section>
        <section id="home-benefits" className="home-benefits-section" aria-labelledby="home-benefits-title">
                            <Container fluid className="home-benefits-container">
                                <div className="home-benefits-intro">
                                    <p className="home-benefits-eyebrow">WHY XENKIA</p>
                                    <h2 id="home-benefits-title">Give customers more ways to explore</h2>
                                    <p>Everything you need to add an interactive 3D experience to your website.</p>
                                </div>

                                <div className="home-benefits-grid">
                                    <article className="home-benefit-card">
                                        <h3>Simple to set up</h3>
                                        <ul>
                                            <li><BenefitIcon type="embed" /><span>Add the browser-based 3D viewer (WebAR) to your existing website with <strong>one line of HTML</strong>—no separate API or app is needed.</span></li>
                                            <li><BenefitIcon type="auto" /><span>Embed code is <strong>generated automatically</strong> when you upload a model and can be edited in Asset Manager.</span></li>
                                            <li><BenefitIcon type="sliders" /><span>The viewer supports <strong>material and variant selection</strong>, plus animation, including when AR is enabled.</span></li>
                                        </ul>
                                    </article>

                                    <article className="home-benefit-card">
                                        <h3>Easy to access</h3>
                                        <ul>
                                            <li><BenefitIcon type="website" /><span>Use the viewer <strong>alongside your existing website and product images</strong> to add an interactive product view.</span></li>
                                            <li><BenefitIcon type="qr" /><span>Customers can <strong>open a model with a button or scan a QR code</strong> using a mobile device with a modern browser.</span></li>
                                            <li><BenefitIcon type="devices" /><span>It runs on <strong>PC, Mac, iOS, and Android</strong> devices, including phones and tablets.</span></li>
                                        </ul>
                                    </article>

                                    <article className="home-benefit-card">
                                        <h3>Made to explore</h3>
                                        <ul>
                                            <li><BenefitIcon type="dimensions" /><span>An online 3D representation helps customers understand a product’s <strong>dimensions and color</strong>.</span></li>
                                            <li><BenefitIcon type="explore" /><span>The interactive viewer gives customers an <strong>immersive way to explore</strong> your products.</span></li>
                                            <li><BenefitIcon type="ar" /><span>On supported phones and tablets, AR lets customers <strong>preview a product in their own space</strong> and make a more confident purchase decision.</span></li>
                                            <li><BenefitIcon type="craft" /><span>Customers can appreciate your <strong>design and craftsmanship</strong> from home.</span></li>
                                        </ul>
                                    </article>
                                </div>
                            </Container>
                        </section>
                </div>


                {/* <div className="why-ar-legacy-section" style={{marginBottom: '0', backgroundColor: '#333333'}}>
                    <Container fluid className="why-ar-legacy-heading">
                        <h2 className="home-header why-ar-legacy-title">Why 3D Viewer with AR capability?</h2>
                    </Container>

                    <Container className="why-ar-legacy-container">
                        <Row className="why-ar-legacy-content">
                            <Col md={5} className="why-ar-legacy-media">
                                <Row style={{justifyContent: 'center'}}>
                                    <img className="why-ar-legacy-image" src="https://xenkia-web-assets.s3-accelerate.amazonaws.com/ezgif.com-gif-maker.gif" alt='A product shown in augmented reality on a phone' />
                                </Row>
                                <a className="why-ar-legacy-video" href="https://www.youtube.com/watch?v=MmnZXvGmnPw&feature=youtu.be" target="_blank" rel="noreferrer" aria-label="Watch the Xenkia AR demo on YouTube">
                                    <img src={youtube_icon} alt="" />
                                </a>
                            </Col>

                            <Col md={7} className="why-ar-legacy-benefits">
                            
                                <p className="home-subheader why-us-item why-ar-legacy-copy"> <b>3D models</b> will increase <b>customer engagement</b> and <b>enrich</b> their <b>shopping experience</b>, which will result in <b>decreased product return</b> and <b>increase in sales</b>. </p>
                                
                                <p className="home-subheader why-us-item why-ar-legacy-copy"> <b>AR 3d models</b> conveys accurate information about the <b>dimension</b> and <b>color</b>, which makes the customer more <b>confident</b> before every <b>online purchase</b>. </p>
                                
                                <p className="home-subheader why-us-item why-ar-legacy-copy"> AR allows the customer to <b>place the product</b> in their <b>immediate environment</b> and check how well it <b>blends into its surroundings</b>. No need for <b>erroneous mental guesswork!</b> </p>
                            </Col>
                        </Row>

                        <hr className="why-ar-legacy-divider" />
                        <Row className="why-ar-legacy-quote">
                            <h3 className="quote-header why-ar-legacy-quote-copy">
                                <i>"I do think that a significant portion of the population of developed countries, and eventually all countries, will have AR experiences every day, 
                                almost like eating three meals a day. It will become that much a part of you."</i>
                            </h3>
                            <h3 className="quote-subheader why-ar-legacy-quote-credit"> —Tim Cook, CEO of Apple Inc. </h3>
                        </Row>
                        <hr className="why-ar-legacy-divider" />
                    </Container>
                </div> */}


      <section id="home-faq" className="home-faq-promo" aria-labelledby="home-faq-promo-title">
                    <Container>
                        <p className="home-faq-promo-eyebrow">NEED A HAND?</p>
                        <h2 id="home-faq-promo-title">Find answers in our FAQ</h2>
                        <p>Browse answers about the 3D viewer, augmented reality, model uploads, and plans.</p>
                        <Link className="home-faq-promo-link" to="/faq">Visit FAQs</Link>
                    </Container>
                </section>
                




      <section id="home-pricing" className="pricing-section">
                    <Container fluid className="pricing-section-container">
                    <h2 className="home-header pricing-section-title">Plans and Pricing</h2>
                    <br/>
                    {/* <p className="home-sub-subtext" style={{textAlign: 'center', color: "black", marginLeft: '5%', marginRight: '5%'}}> <i>Get <b style={{color: '#FF5722'}}>30% discount<sup><i style={{color: '#FF5722'}}>*</i></sup></b> on <b>yearly subscriptions</b></i> </p> */}
                    

                    {/* <div style={{textAlign: 'center', maxWidth: ''}}> 
                        <p>We have created distinct packages depending on the </p>
                    </div> */}
                    {/* <p className="home-subtext">Depending on whether you are an Individual, a Team or a Company, you will have certain needs in terms of allocated quota for uploads, views/download, size of the 3d model, storage etc. <br/>In order to prevent clutter we have grouped 6 distinct packages in two separate groups, that you can select visa the following two buttons. </p> */}
                    {/* <p className="home-subtext pricing-section-intro"> Whether you are <b>an Individual or an Enterprise</b>, choose from any of the <b>6 distinct packages</b> based on your needs. </p> */}
                    <div className="pricing-audience-switch" role="group" aria-label="Choose a pricing audience">
                        <Button className={`pricing-audience-button${this.state.individualOrCompany === 0 ? " is-active" : ""}`} variant="light" size="lg" aria-pressed={this.state.individualOrCompany === 0} onClick={() => this.setState({individualOrCompany: 0})}> <IndividualIcon /> Individual </Button>
                        <Button className={`pricing-audience-button${this.state.individualOrCompany === 1 ? " is-active" : ""}`} variant="light" size="lg" aria-pressed={this.state.individualOrCompany === 1} onClick={() => this.setState({individualOrCompany: 1})}> <EnterpriseIcon /> Enterprise </Button>
                    </div>
                    <div className="pricing-billing-selector" role="group" aria-label="Choose a billing period">
                        <span className="pricing-billing-label">Billing period</span>
                        <div className="pricing-billing-options">
                            <button type="button" className={`pricing-billing-option${this.state.billMonthlyOrYearly === 'Monthly' ? ' is-active' : ''}`} aria-pressed={this.state.billMonthlyOrYearly === 'Monthly'} onClick={() => this.selectBillingCycle('Monthly')}>Monthly</button>
                            <button type="button" className={`pricing-billing-option${this.state.billMonthlyOrYearly === 'Yearly' ? ' is-active' : ''}`} aria-pressed={this.state.billMonthlyOrYearly === 'Yearly'} onClick={() => this.selectBillingCycle('Yearly')}>Yearly <span className="pricing-billing-savings">Save 30%*</span></button>
                        </div>
                    </div>
                    {/* <p className="pricing-selection-hint"><i><b>**Click to explore pricing-plan tailored to your needs.</b></i></p> */}

                    <Container fluid className="pricing-plans-container">
                        {this.state.individualOrCompany === 0
                        ?
                            <section>
                                <Row className="pricing-plans-grid">
                                    {individualPricingPlan}
                                </Row>
                            </section>
                        :
                            <section>
                                <Row className="pricing-plans-grid">
                                    {companyPricingPlan}
                                </Row>
                            </section>
                        }
                    </Container>
                    <br/>
                    
                    {/* <Container fluid className="pricing-notes">
                        <div>
                            <p className="foot-note" style={{textAlign: 'justify', color: "black"}}> <b>Note:</b> </p>
                            <p className="foot-note" style={{textAlign: 'justify', color: "black"}}> <b style={{color:'#FF5722'}}>*</b> <i>Get <b style={{color: '#FF5722'}}>30% discount</b> on <b>yearly subscriptions</b>.</i> </p>
                            <p className="foot-note" style={{textAlign: 'justify', color: "black"}}> <b style={{color:'#FF5722'}}>**</b> You are free to <b>choose from any of the 6 packages</b> you want based on your need, <b>regardless of whether you are an Individual or a Company</b>. The packages were designed primarily keeping in mind <b>the traffic our users might expect in their website</b>. </p>
                            <p className="foot-note" style={{textAlign: 'justify', color: "black"}}> <b style={{color:'#FF5722'}}>***</b> <i>The <b>Views/Downloads</b> per month <b>does not</b> include the views from the Asset Manager. <b>Only your customers views are counted</b>.</i> </p>
                        </div>
                    </Container> */}
                    <br/>
                    <br/>
                    </Container>
                </section>



      <div id="home-footer-boundary" aria-hidden="true" />
      <HomeFooter />
      <HomePageIndex />
                
            </div>
        )
    }    
}

//export default windowSize(Home);
export default Home;
